import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Icon from "../components/Icon";
import { AuditBlock } from "../components/SignOff";
import ReportActions from "../components/ReportActions";
import { apiGet } from "../api";
import { workTypeLabel } from "../constants";
import { formatYmd, formatStamp } from "../dateutil";
import { C, R, S } from "../theme";

const retestLabel = (r) => (r === "pass" ? "Retest PASS" : r === "fail" ? "Retest FAIL" : "-");

export default function MaintenanceDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [m, setM] = useState(null);
  useEffect(() => { apiGet(`/maintenance/${id}`).then(setM); }, [id]);
  if (!m) return <div style={{ color: C.amber, textAlign: "center", paddingTop: 80 }}>Loading…</div>;
  const row = (l, v) => <div style={{ display: "flex", justifyContent: "space-between", padding: `${S.sm}px 0`, borderBottom: `1px solid ${C.border}` }}><span style={{ color: C.muted }}>{l}</span><span style={{ color: C.text, fontWeight: 700, textAlign: "right", marginLeft: S.md }}>{v}</span></div>;
  const signer = m.signed_by_name || m.technician_name;
  const img = (src, label) => (<><div style={{ color: C.sub, fontSize: 13, fontWeight: 700, textTransform: "uppercase", marginTop: S.md, marginBottom: S.xs }}>{label}</div><img src={src} alt={label} style={{ width: "100%", borderRadius: R.md }} /></>);
  return (
    <div className="fade-up">
      <div style={{ display: "flex", alignItems: "center", gap: S.sm, padding: S.lg }}>
        <button className="pressable" onClick={() => nav(-1)}><Icon name="chevron-back" size={28} color={C.text} /></button>
        <div className="display" style={{ color: C.text, fontSize: 20, fontWeight: 900 }}>Maintenance Record</div>
      </div>
      <div style={{ padding: S.lg }}>
        <div style={{ background: C.card, borderRadius: R.md, padding: S.md, border: `1px solid ${C.border}` }}>
          {row("Attraction", m.attraction_name)}{row("Type", workTypeLabel(m.work_type))}{row("Date", formatYmd(m.work_date))}{row("Technician", m.technician_name)}
          {m.component && row("Component", m.component)}
          {m.parts_replaced && row("Parts replaced", m.parts_replaced)}
          {m.retest_outcome && row("Retest", retestLabel(m.retest_outcome))}
          {m.location && row("Location", m.location)}
        </div>
        {!!m.defect_description && (<><div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Defect / Fault Found</div><div style={{ background: C.card, borderRadius: R.md, padding: S.md, border: `1px solid ${C.border}`, color: C.text, lineHeight: 1.5 }}>{m.defect_description}</div></>)}
        <div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Work Carried Out</div>
        <div style={{ background: C.card, borderRadius: R.md, padding: S.md, border: `1px solid ${C.border}`, color: C.text, lineHeight: 1.5 }}>{m.description}</div>
        {!!m.before_photo && img(m.before_photo, "Before")}
        {!!m.after_photo && img(m.after_photo, "After")}
        {!!m.photo && img(m.photo, "Additional photo")}
        {(m.signature || m.signed_by_name) && (
          <>
            <div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Operator Sign-Off</div>
            <AuditBlock signature={m.signature} name={signer} initials={m.signed_by_initials} submittedAt={m.created_at} />
          </>
        )}
        <div style={{ height: S.md }} />
        <ReportActions report={{
          title: `Repair Log — ${m.attraction_name}`,
          company: m.attraction_name,
          rows: [], columns: [],
          photos: [
            m.before_photo ? { label: "Before", dataUri: m.before_photo } : null,
            m.after_photo ? { label: "After", dataUri: m.after_photo } : null,
            m.photo ? { label: "Additional photo", dataUri: m.photo } : null,
          ].filter(Boolean),
          meta: {
            details: [
              { label: "Attraction", value: m.attraction_name }, { label: "Type", value: workTypeLabel(m.work_type) },
              { label: "Date", value: formatYmd(m.work_date) }, { label: "Technician", value: m.technician_name },
              { label: "Component", value: m.component }, { label: "Defect found", value: m.defect_description },
              { label: "Parts replaced", value: m.parts_replaced }, { label: "Retest", value: m.retest_outcome ? retestLabel(m.retest_outcome) : null },
              { label: "Location", value: m.location }, { label: "Work carried out", value: m.description },
            ],
            signature: m.signature, signedBy: signer, initials: m.signed_by_initials, submittedAt: formatStamp(m.created_at),
            docType: "MR", recordId: m.id, siteLocation: m.location, attractionName: m.attraction_name,
          },
        }} />
        <div style={{ height: S.xxl }} />
      </div>
    </div>
  );
}
